import { ActionType, getType } from 'typesafe-actions'
import { IEntityHashMap } from 'flux-entities'

import * as actions from './actions'
import { IUsersState, createInitialUsersState } from './types'
import { IUser } from '../../types/user'

type TAction = ActionType<typeof actions>

const initialUsersState = createInitialUsersState()

const usersReducer = (state = initialUsersState, action: TAction): IUsersState => {
  switch (action.type) {
    case getType(actions.usersError): {
      return {
        ...state,
        errors: action.payload,
        touched: true,
        loading: false,
      }
    }

    case getType(actions.usersRequest): {
      return {
        ...state,
        touched: true,
        loading: true,
      }
    }

    case getType(actions.usersSuccess): {
      const all: IEntityHashMap<IUser> = {}
      const ids: number[] = []

      for (const user of action.payload) {
        if (!all[user.id]) {
          ids.push(user.id)
          all[user.id] = user
        }
      }

      return {
        all,
        ids,
        touched: true,
        loading: false,
        errors: [],
      }
    }

    case getType(actions.userUpdateError): {
      return {
        ...state,
        errors: action.payload,
        touched: true,
        loading: false,
      }
    }

    case getType(actions.userUpdateRequest): {
      return {
        ...state,
        touched: true,
        loading: true,
      }
    }

    case getType(actions.userUpdateSuccess): {
      return {
        ...state,
        all: {
          ...state.all,
          [action.payload.id]: action.payload,
        },
        touched: true,
        loading: false,
        errors: []
      }
    }
  }

  return state
}

export {
  usersReducer,
  initialUsersState
}
